import React from 'react';
import { StylesConfig, ValueType } from 'react-select';

import MAddressInput from 'app/ui/MAddressInput/MAddressInput';

interface Props {
  className?: string;
  placeholder?: string;
  name: string;
  value: string | null;
  customStylesSelect?: StylesConfig<{ label: string; value: string }, false>;
  disabled?: boolean;
  onChange: (value: ValueType<{ label: string; value: string }, false>) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
  onMenuClose?: () => void;
}

const MFormAddressInputView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MAddressInput
      className={props.className}
      placeholder={props.placeholder}
      name={props.name}
      value={props.value}
      customStylesSelect={props.customStylesSelect}
      disabled={props.disabled}
      onChange={props.onChange}
      onBlur={props.onBlur}
      onMenuClose={props.onMenuClose}
    >
      {props.children}
    </MAddressInput>
  );
};

MFormAddressInputView.displayName = 'MFormAddressInputView';
MFormAddressInputView.defaultProps = {};

export default MFormAddressInputView;
